import { render } from "./list-lookup.vue?vue&type=template&id=39c51ed1"
import script from "./list-lookup.vue?vue&type=script&lang=js"
export * from "./list-lookup.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__